import styled from 'styled-components';

export default {
    OutlinedButton: styled.a.attrs({ className: 'button-outlined' })`
        height: 48px;
        padding: 0 25px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        color: #1A1A1A;
        background: #FFFFFF;
        border: 1px solid #B9C0C2;
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-size: 11px;
        grid-column-start: 1;
        grid-column-end: 3;
        width: 100%;
        box-sizing: border-box;
        margin-top: 17px;
        position: relative;
        
        &:after{
          content: '';
          display: block;
          position: absolute;
          background: #1A1A1A;
          height: 1px;
          width: 25px;
          right: 25px;
          top: 50%;
          transition: 0.2s ease-in-out;
        }
        &:active, &:hover {
            background: #1A1A1A;
            color: #FFFFFF;
            &:after{
              background: #FFFFFF;  
            }
        }
        @media (max-width: 320px) {
            padding: 14px 30px 16px;
        }
        @media (min-width: 700px) {
            padding: 15px 24px 16px;
            margin: 0;
            max-width: ${props => props.status ? '282px' : '280px'};
            max-height: 48px;
        }
    `,
};
